import React from "react";
const ImageWithPlaceholder = (props) => {
    const { src, className, type = "user" } = props;
    const placeholderName = type === "user"
        ? "user-placeholder.jpg"
        : "mission-avatar-placeholder.png";
    return (React.createElement("img", { src: src, className: className, alt: "", onError: (e) => {
            const target = e.target;
            target.onerror = null;
            target.src = `/public/images/placeholders/${placeholderName}`;
        } }));
};
export default React.memo(ImageWithPlaceholder);
